var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divPadreIngresos" },
    [
      _c(
        "v-flex",
        { attrs: { sm9: "", md9: "", layout: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { sm4: "", md4: "" } },
            [
              _c("v-combobox", {
                attrs: {
                  label: "Telco",
                  items: _vm.telcoOptions,
                  "item-text": "telconame",
                  "item-value": "telcoid",
                  dense: ""
                },
                on: { change: _vm.getPlanOptions },
                model: {
                  value: _vm.telco,
                  callback: function($$v) {
                    _vm.telco = $$v
                  },
                  expression: "telco"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm4: "", md4: "" } },
            [
              _vm.telco
                ? _c("v-combobox", {
                    attrs: {
                      label: "Plan",
                      items: _vm.planOptions,
                      "item-text": "telcoplanname",
                      "item-value": "telcoplanid",
                      dense: ""
                    },
                    model: {
                      value: _vm.plan,
                      callback: function($$v) {
                        _vm.plan = $$v
                      },
                      expression: "plan"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("v-flex", { attrs: { sm4: "", md4: "" } }, [
            _c("div", { staticClass: "text-sm-center" })
          ]),
          _c(
            "v-flex",
            { attrs: { sm4: "", md4: "" } },
            [
              _c("DatePicker", {
                attrs: {
                  label: "Fecha de Ingreso Desde",
                  max: _vm.fechaMaxima
                },
                model: {
                  value: _vm.fechaInicio,
                  callback: function($$v) {
                    _vm.fechaInicio = $$v
                  },
                  expression: "fechaInicio"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm4: "", md4: "" } },
            [
              _c("DatePicker", {
                attrs: {
                  label: "Fecha de Ingreso Hasta",
                  max: _vm.fechaMaxima
                },
                model: {
                  value: _vm.fechaFin,
                  callback: function($$v) {
                    _vm.fechaFin = $$v
                  },
                  expression: "fechaFin"
                }
              })
            ],
            1
          ),
          _c("v-flex", { attrs: { sm4: "", md4: "" } }, [
            _c(
              "div",
              { staticClass: "text-sm-center" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.handleBuscarClick } },
                  [
                    _c("v-icon", [_vm._v("search")]),
                    _vm._v("Filtrar\n        ")
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  { on: { click: _vm.clearFilters } },
                  [_c("v-icon", [_vm._v("clear")]), _vm._v("Limpiar ")],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", small: "", color: "primary" },
                    on: { click: _vm.getCSV }
                  },
                  [
                    _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                      _vm._v("cloud_download")
                    ]),
                    _vm._v("\n            \n          "),
                    _c("span", { staticClass: "importExportBtnTexto" }, [
                      _vm._v("Exportar"),
                      _c("br"),
                      _vm._v("CSV")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "divIngresos" },
        [
          _vm.info.length
            ? _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: { label: "Buscar...", "append-icon": "search" },
                    model: {
                      value: _vm.busqueda,
                      callback: function($$v) {
                        _vm.busqueda = $$v
                      },
                      expression: "busqueda"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("v-flex", { attrs: { xs12: "", sm6: "", md4: "" } }, [_c("div")]),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  staticClass: "btnCrear",
                  on: {
                    click: function($event) {
                      _vm.abrirModal = true
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { dark: "", left: "" } }, [
                    _vm._v("add_circle_outline")
                  ]),
                  _c("span", [_vm._v("Crear")])
                ],
                1
              ),
              _c(
                "ModalMantenedor",
                { attrs: { show: _vm.abrirModal } },
                [
                  _c(
                    "CabeceraModalSim",
                    {
                      attrs: {
                        mostrarBtnVolver: _vm.mostrarBtnVolver,
                        mostrarBtnContinuar: _vm.mostrarBtnContinuar,
                        mostrarBtnGuardar: _vm.mostrarBtnGuardar,
                        permitirCont: _vm.permitirCont,
                        permitirGuard: _vm.permitirGuard
                      },
                      on: {
                        cerrar: _vm.cerrarModalCrear,
                        volver: _vm.volv,
                        continuar: _vm.cont,
                        guardar: _vm.guard
                      }
                    },
                    [
                      _c("NavegacionModalCrud", {
                        attrs: { pasos: _vm.pasos, "estado-id": _vm.estadoId },
                        on: {
                          continuar: _vm.btnModalContinuar,
                          guardar: _vm.btnModalGuardar
                        },
                        model: {
                          value: _vm.pasoActivoIndex,
                          callback: function($$v) {
                            _vm.pasoActivoIndex = $$v
                          },
                          expression: "pasoActivoIndex"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-stepper",
                    {
                      model: {
                        value: _vm.pasoActivoIndex,
                        callback: function($$v) {
                          _vm.pasoActivoIndex = $$v
                        },
                        expression: "pasoActivoIndex"
                      }
                    },
                    [
                      _c("CrudStepperHeader", {
                        attrs: {
                          pasos: _vm.pasos,
                          "paso-activo-index": _vm.pasoActivoIndex
                        }
                      }),
                      _c(
                        "CrudStepperItems",
                        [
                          _c(
                            "CrudStepperContent",
                            { attrs: { paso: _vm.pasos.ingresoDeSim } },
                            [
                              _c("ComponenteDialogo", {
                                attrs: {
                                  modalContinuar: _vm.continuarModal,
                                  telcoOptions: _vm.telcoOptions
                                },
                                on: { objCreacion: _vm.objCreacion }
                              })
                            ],
                            1
                          ),
                          _c(
                            "CrudStepperContent",
                            { attrs: { paso: _vm.pasos.lecturaExcel } },
                            [
                              _c("LecturaExcel", {
                                on: {
                                  excel: _vm.excelReaded,
                                  sinExcel: _vm.quitarGuardar
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card autoHeightGrid" },
        [
          _c("TablaSimSolicitudes", {
            attrs: { solicitudes: _vm.info, busqueda: _vm.busqueda },
            on: { rerenderTabla: _vm.handleBuscarClick }
          })
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showReporteGenerado = false
                                  _vm.textoModalReporte = ""
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.textoModalReporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Reportes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm.showPopUpReport
        ? _c("PopUpGeneratedReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }